import React from "react";
import { PropTypes } from "prop-types";
import { PATHS } from "config/paths";
import { Link } from "components/core/Link";
import { H3, H4, Paragraph } from "components/core/Typography";
import { Clock } from "components/core/Icons";
import { BannerWithIcon } from "components/core/BannerWithIcon";

import "./UnitReservationDrawer.scss";

const UnitReservationDrawer = ({ children }) => (
	<div className="unit-reservation-drawer">
		{/* HEADER */}
		<div className="drawer-header">
			<H3 last>Make a Free Reservation Now</H3>
			<Paragraph color="gray">
				It is <strong>FREE</strong> to reserve this unit. Lock in this
				rate and special offer. No obligation and no credit card required.
			</Paragraph>
			<BannerWithIcon
				icon={<Clock />}
				text="We are experiencing higher than normal call volume. RESERVE FOR FREE ONLINE
					for faster service!"
				theme="background-orange"
			/>
		</div>
		<div className="drawer-content">
			{children}
		</div>
		<div className="drawer-footer">
			<H4 last>Rental Conditions</H4>
			<Paragraph color="gray" last>
				No obligation to rent. By clicking to reserve this unit, you
				agree to our <Link underline href={PATHS.TERMS}>Terms of Use</Link> and{" "}
				<Link underline href={PATHS.PRIVACY}>Privacy Policy</Link>.
			</Paragraph>
		</div>
	</div>
);

UnitReservationDrawer.propTypes = {
	children: PropTypes.node.isRequired
}

export default UnitReservationDrawer;
